export const removeOldDotDillardsCookies = () => {
    $.removeCookie('CoreID6', {
        path: '/',
        domain: '.dillards.com'
    });
    $.removeCookie('CoreM_State', {
        path: '/',
        domain: '.dillards.com'
    });
    $.removeCookie('CoreM_State_Content', {
        path: '/',
        domain: '.dillards.com'
    });
};